import { createContext, useContext, useState, useEffect } from 'react'

const LayoutContext = createContext(null)

export function LayoutProvider ({ children }) {
  const [headerOverride, setHeaderOverride] = useState(null) // null = no override
  const [footerOverride, setFooterOverride] = useState(null)

  const value = {
    headerOverride,
    footerOverride,
    setHeaderOverride,
    setFooterOverride
  }

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  )
}

export function useLayout () {
  const ctx = useContext(LayoutContext)
  if (!ctx) throw new Error('useLayout must be used within LayoutProvider')
  return ctx
}

/**
 * Hook for temporary chrome visibility overrides (auto-cleanup)
 *
 * @example
 * useLayoutVisibility({ header: false, footer: false })
 */
export function useLayoutVisibility ({ header = null, footer = null }) {
  const { setHeaderOverride, setFooterOverride } = useLayout()

  useEffect(() => {
    if (header !== null) setHeaderOverride(header)
    if (footer !== null) setFooterOverride(footer)

    return () => {
      if (header !== null) setHeaderOverride(null)
      if (footer !== null) setFooterOverride(null)
    }
  }, [header, footer, setHeaderOverride, setFooterOverride])
}
